module.exports = __webpack_public_path__ + "assets/img/center-0df0454b.png";